<footer id="footer" class="d-flex flex-column py-4">
  <!-- <div *ngIf="esgSection || vcfSection" class="container py-3">
  <div class="row">
    <div class="col-md-12">
      <div class="text-center" display="none">
        <span *ngIf="esgSection"
          >Hai bisogno di assistenza sulla piattaforma ESG?</span
          >&nbsp;
          <span *ngIf="vcfSection"
            >Hai bisogno di assistenza sulla piattaforma Verifica Crediti Bonus
            Edilizi?</span
            >&nbsp;
            <a class="handPointer" (click)="goToHelpDeskBandi()" translate
              >help-desk.help-link</a
              >
            </div>
            <div class="text-center" *ngIf="!isUserSmart">
              Nella sezione FAQ puoi trovare velocemente la risposta alle tue
              domande.
              <a class="handPointer" (click)="goToFAQBandi()">
                Entra e cerca per categoria >
              </a>
            </div>
          </div>
        </div>
      </div> -->

      @if (!directChannel) {
        <div class="px-4 row gx-0 align-items-center w-100">
          <div class="col-7 text-start">
            ©{{creationYearPlatform}} - {{ currentYear }} PwC. All rights reserved. PwC refers to the PwC network and/or one or more
            of its member firms, each of which is a separate legal entity. Please see pwc.com/structure for further details.
          </div>
          <div class="col-5 text-end row gx-0">
            <div class="col-12">
              {{'footer.coe.need-help' | translate }} <a class="handPointer" (click)="goToHelpDeskBandi()">{{'footer.coe.help-desk-link' | translate}}</a>
            </div>
            <a class="handPointer col-12" (click)="downloadGeneralConditions()" target="_blank">
              {{'footer.download.general-condition' | translate}}
            </a>
            <a class="handPointer col-12" (click)="downloadPrivacyPolicy()" target="_blank">
              {{'footer.download.privacy' | translate}}
            </a>
          </div>
        </div>
      }
      <!-- COE FOOTER -->
      @if (directChannel) {
        <div class="px-4 row align-items-center w-100 gx-0">
          <div class="col-7 text-start">
            ©{{creationYearPlatform}} - {{currentYear}} {{'footer.coe.text' | translate }}
          </div>
          <div class="col-5 text-end row gx-0">
            <div class="col-12">
              {{'footer.coe.need-help' | translate }} <a class="handPointer" (click)="goToHelpDeskBandi()">{{'footer.coe.help-desk-link' | translate}}</a>
            </div>
            <a class="handPointer col-12" (click)="downloadGeneralConditions()" target="_blank">
              {{'footer.download.general-condition' | translate}}
            </a>
            <a class="handPointer col-12" (click)="downloadPrivacyPolicy()" target="_blank">
              {{'footer.download.privacy' | translate}}
            </a>
          </div>
        </div>
      }
    </footer>
